<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div [innerHTML]="safeMessage"></div>
    <input type="text" class="form-control" [(ngModel)]="value" [placeholder]="placeholder"
        (keyup.enter)="onConfirm()" />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()">OK</button>
</div>